// extracted by mini-css-extract-plugin
export default {"row":"vendor-vip_row__haic-","mt_16":"vendor-vip_mt_16__WL9Dz"};